/* global angular */

var ngModule = angular.module('trends');

ngModule.service('$history', ['$state', function($state) {

  var history = [];

  angular.extend(this, {
    push: function(state, params) {
      history.push({ state: state, params: params });
    },
    all: function() {
      return history;
    },
    go: function(step) {
      var prev = this.previous(step || -1);
      return $state.go(prev.state, prev.params);
    },
    previous: function(step) {
      return history[history.length - Math.abs(step || 1)];
    },
    back: function() {
      return this.go(-1);
    }
  });

}]).run(['$history', '$state', '$rootScope', '$timeout', '$location', 'TagManager',
    function($history, $state, $rootScope, $timeout, $location, TagManager) {
        $rootScope.$on('$stateChangeSuccess', function(event, to, toParams, from, fromParams) {
            if (!from.abstract) {
                $history.push(from, fromParams);
            }

            // Track page view during next digest to allow page title to be set
            if (!to.noAnalyticsPageview) {
                $timeout(function () {
                    TagManager.pageView();
                }, 0);
            }
        });

        $history.push($state.current, $state.params);
    }
]);
